import { z } from 'zod';

/** Free-tier 429 `error.details` from `rateLimitError` (BR-36 / PRE-7). */
export const rateLimitDetailsSchema = z.object({
  kind: z.enum(['session', 'hint']),
  limit: z.number().int().nonnegative(),
  used: z.number().int().nonnegative(),
  resetsAt: z.string(),
  upgrade: z.boolean().optional(),
});

export type RateLimitDetails = z.infer<typeof rateLimitDetailsSchema>;
